import React from 'react'
import styled from 'styled-components'


// Import Page Components
import FunctionalComponentBlindOrigin from '../../../FunctionalComponents/FunctionalComponentBlindOrigin.js'
import FunctionalComponentBlindDestination from '../../../FunctionalComponents/FunctionalComponentBlindDestination.js'
import InputCalendar from '../../../InputComponents/InputCalendar.js'
import NavigationRouteAndSchedule from '../../../PageComponents/Navigation/Quote/NavigationRouteAndSchedule.js'

const GContentRouteAndSchedule = styled.div`
  background: transparent;
  // 🖋
  font-family: 'Open Sans';
  // 📰
  display: grid;
  margin-top: 20px;
  grid-template-rows: 250px 250px 175px 150px;
  grid-template-columns: 1fr;
  grid-template-areas:
    "sg_blind_origin"
    "sg_blind_destination"
    "sg_calendar_input"
    "sg_navigation_stepper";

  .SGBlindOrigin {
    grid-area: sg_blind_origin; // 🗺
    background: none !important;
  }
  .SGBlindDestination {
    grid-area: sg_blind_destination; // 🗺
    background: none !important;
  }
  .SGCalendarInput {
    grid-area: sg_calendar_input; // 🗺
    background: none !important;
    justify-self: start;
  }
  .SGNavigationStepper {
    grid-area: sg_navigation_stepper; // 🗺
    background: none !important;
    align-self: start;
  }
`;

const SGBlindOrigin = styled.div`

`;
const SGBlindDestination = styled.div`

`;
const SGCalendarInput = styled.div`

`;
const SGNavigationStepper = styled.div`

`;

const SGCalendarTest = styled.div`
  display: grid;
  margin: 0 auto;
  max-width: 1360px;
  grid-template-rows: 0.5fr;
  grid-template-columns: 1fr;
  grid-template-areas:
    "sg_blind_origin";
    
  .InputSearchShipment {
    grid-area: sg_input_search_shipment; // 🗺
    align-self: start;
    justify-self: start;
  }
`;



const EchoShipGridComponentContent = () => {
  return (

    <GContentRouteAndSchedule>
      <SGBlindOrigin>
          <FunctionalComponentBlindOrigin>

          </FunctionalComponentBlindOrigin>
      </SGBlindOrigin>

      <SGBlindDestination>
          <FunctionalComponentBlindDestination></FunctionalComponentBlindDestination>
      </SGBlindDestination>

      <SGCalendarInput>
          <SGCalendarTest>
              <InputCalendar></InputCalendar>
          </SGCalendarTest>
      </SGCalendarInput>

      <SGNavigationStepper>
        <NavigationRouteAndSchedule></NavigationRouteAndSchedule>
      </SGNavigationStepper>


    </GContentRouteAndSchedule>

  )
}

export default EchoShipGridComponentContent;
